var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['kws-quiz', _vm.themeClass],attrs:{"id":_vm.id}},[(_vm.initialized)?_c(_vm.type,{tag:"component",class:_vm.additionalClasses,attrs:{"id":_vm.id,"introduction":_vm.introduction,"questions":_vm.questions,"result":_vm.result,"outro":_vm.outro}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }